/* eslint-disable react/destructuring-assignment */
import React from 'react';
import format from 'date-fns/format';
import { textEllipsis } from '../../../shared/utils/smartutils';

export default function (t) {
  return [
    {
      title: t('general.date'),
      field: 'date',
      render: (rowData) => format(new Date(rowData.date), 'dd/MM/yyyy'),
    },
    {
      title: t('general.theme'),
      field: 'theme',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.theme}>
          {rowData.theme}
        </span>
      ),
    },
    {
      title: t('general.discipline'),
      field: 'discipline',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.discipline}>
          {rowData.discipline}
        </span>
      ),
    },
    {
      title: t('general.teacher'),
      field: 'teacher',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.teacher}>
          {rowData.teacher}
        </span>
      ),
    },
    {
      title: t('general.class'),
      field: 'class',
      cellStyle: textEllipsis,
      render: (rowData) => (
        <span className="tooltip-test" title={rowData.class}>
          {rowData.class}
        </span>
      ),
    },
    { title: t('general.status'), field: 'status' },
  ];
}
